export default __webpack_public_path__ + "static/media/clouds-left-tablet.47afe52c.png";